/**
 * PKCE (RFC 7636) for the staff door.
 *
 * The staff client is public: a browser cannot hold a Cognito client secret. The verifier
 * stays in sessionStorage on this origin for the duration of the redirect; it is not a
 * credential to anything else. The private half of a signing key never appears here.
 *
 * DEVELOPMENT / PREVIEW ONLY. The authorization server is paper until there is a go.
 * See docs/STAFF-DOOR.md.
 */

const VERIFIER_BYTES = 32;

function base64Url(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export function randomVerifier(): string {
  const bytes = new Uint8Array(VERIFIER_BYTES);
  crypto.getRandomValues(bytes);
  return base64Url(bytes);
}

export async function challengeS256(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return base64Url(new Uint8Array(digest));
}

export async function createPkcePair(): Promise<{ verifier: string; challenge: string }> {
  const verifier = randomVerifier();
  return { verifier, challenge: await challengeS256(verifier) };
}

export function randomState(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return base64Url(bytes);
}
